import { useState, useMemo } from "react";
import EmpresaUtil from "../utils/EmpresaUtil";

const useEmpresa = () => {
  const [empresa] = useState(EmpresaUtil[Number(process.env.REACT_APP_COMPANY)]);

  return useMemo(() => {
    return empresa;
  }, [empresa]);
};

export default useEmpresa;